'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _panel = require('@/components/panel');

var _panel2 = _interopRequireDefault(_panel);

var _cropperjs = require('cropperjs');

var _cropperjs2 = _interopRequireDefault(_cropperjs);

var _formLayout = require('@/components/form-layout');

var _formLayout2 = _interopRequireDefault(_formLayout);

require('./cropper.min.css');

var _utils = require('@/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    /**
     * 1:只显示图片选择区域
     * 2:只显示图片裁剪区域
     * 3:显示图片选择及图片裁剪
     */
    layout: {
      type: Number,
      default: 3
    },
    /**
     * 图片选择区域{title: '',list:[]}
     */
    pitch: {
      type: Object,
      default: function _default() {
        return {
          title: '默认头像',
          list: function () {
            var req = require.context('@/static/images/course');
            return req.keys().map(req);
          }()
        };
      }
    },
    /**
     * 裁剪区域{title:'',aspectRatio:5/3}
     */
    crop: {
      type: Object,
      default: function _default() {
        return {
          title: '自定义头像',
          aspectRatio: 1 / 1
        };
      }
    },
    courseId: {
      type: String,
      default: ''
    },
    imgUrl: {
      type: String,
      default: ''
    },
    imgName: {
      type: String,
      default: ''
    },
    showDefault: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      select: {},
      cropper: {},
      haveImg: false, //如果初始有图片，将这里设为true
      resourcesName: '', //上传的图片名称
      whetherShow: false
    };
  },
  created: function created() {
    this.imagePath = _utils.imagePath;
  },
  mounted: function mounted() {
    this.initRadioHeight();
    this.initCropper();
    if (!this.imgUrl) {
      if (this.showDefault) {
        this.changeSelect(0); //刚开始默认选中第一张图片
      }
    } else {
      this.cropper.replace(this.imagePath('course', this.imgUrl));
      this.haveImg = true;
      this.resourcesName = this.imgName || 'thumb.png';
      this.whetherShow = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.cropper = null;
  },

  methods: {
    initCropper: function initCropper(url) {
      var img = document.querySelector('#cropimg');
      this.cropper = new _cropperjs2.default(img, {
        dragMode: 'move',
        preview: '#preview',
        aspectRatio: this.crop.aspectRatio,
        rotatable: false
      });
    },
    initRadioHeight: function initRadioHeight() {
      var _this = this;

      (0, _from2.default)(document.querySelectorAll('.iv-cropper-wrapper')).forEach(function (item) {
        var w = parseInt(getComputedStyle(item).width);
        item.style.height = (_this.crop.aspectRatio <= 1 ? w * _this.crop.aspectRatio : w / _this.crop.aspectRatio) + 'px';
      });
    },
    changeSelect: function changeSelect(index) {
      //如果点击的是同一个，那么就是取消选择
      var isCancel = this.select[index];
      this.select = {};
      !isCancel && this.$set(this.select, index, true) && this.cropper.replace(this.pitch.list[index]);
      this.haveImg = isCancel ? null : true;
      if (this.pitch.list[index]) {
        var a = this.pitch.list[index].split('/');
        for (var i = 0; i < a.length; i++) {
          if (a[i] == '') {
            a.splice(i, 1);
          }
        }
        this.resourcesName = a[2];
      }
      !isCancel ? this.whetherShow = true : this.whetherShow = false;
      //清空选择区域
      isCancel && this.cropper.destroy() && this.initCropper();
    },

    /**
     * 选择文件后
     */
    handleChange: function handleChange(e) {
      var _this2 = this;

      var file = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function () {
        _this2.cropper.replace(reader.result);
        reader.onload = null;
      };
      if (file.name) {
        this.resourcesName = file.name;
        this.whetherShow = true;
      }
      reader.readAsDataURL(file);
      this.haveImg = true;
    },
    onFileUpload: function onFileUpload() {
      var _this3 = this;

      return new _promise2.default(function (resolve, reject) {
        if (_this3.isIE()) {
          var can = _this3.cropper.getCroppedCanvas();
          var picData = can.toDataURL();
          var idBlob = _this3.processData(picData);
          _this3.requestFn(idBlob, resolve);
        } else {
          _this3.cropper.getCroppedCanvas().toBlob(function (blob) {
            _this3.requestFn(blob, resolve);
          }, 'image/jpeg');
        }
      });
    },

    //抽离的上传图片ajax
    requestFn: function requestFn(blob, resolve) {
      var formData = new FormData();
      formData.append('serviceCode', 'cover-image');
      formData.append('_t', Math.random());
      formData.append('file', blob, this.resourcesName);
      var imageSize = 1048576 * 2;
      // if (blob.size > imageSize) return Promise.reject(new Error('所选文件超过2M，请重新上传'))
      if (blob.size > imageSize) return this.$Message.error('所选文件超过2M，请重新上传');
      this.$ajax({
        method: 'POST',
        url: 'zuul/api-file/portal/file',
        data: formData
      }).then(function (res) {
        resolve({
          success: res.data.code == 2000,
          message: res.data.message,
          data: res.data.data,
          url: res.data.code == 2000 ? 'api-file/portal/file/stream/' + res.data.data.fileID + '?origin=true' : ''
        });
      });
    },

    //ie下解决图片
    processData: function processData(dataUrl) {
      var binaryString = window.atob(dataUrl.split(',')[1]);
      var arrayBuffer = new ArrayBuffer(binaryString.length);
      var intArray = new Uint8Array(arrayBuffer);
      for (var i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i);
      }
      var data = [intArray],
          blob = void 0;
      try {
        blob = new Blob(data, {
          type: 'image/png'
        });
      } catch (e) {
        // window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder
        // if (e.name === 'TypeError' && window.BlobBuilder) {
        //   let builder = new BlobBuilder()
        //   builder.append(arrayBuffer)
        //   //blob = builder.getBlob(imgType) // imgType为上传文件类型，即 file.type
        // } else {
        //   console.log('版本过低，不支持上传图片')
        // }
      }
      return blob;
    },

    //判读是否是ie浏览器
    isIE: function isIE() {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true;
      } else {
        return false;
      }
    },

    //取消上传
    cancelUpload: function cancelUpload() {
      this.select = {};
      this.haveImg = false;
      this.whetherShow = false;
      this.cropper.destroy();
      this.initCropper();
    }
  },
  components: {
    Panel: _panel2.default,
    FormLayout: _formLayout2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//